// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"161":"31ddc3b30027eb6f3cc2","1766":"d1d1a805e05d7040356e","2097":"721ce5a7aeb4689c15f8","7494":"7be200a786fc32750a7b","8278":"929176ac5608213dc576"}[chunkId] + ".js";
};